export default __webpack_public_path__ + "static/media/mamut_xl1.54f2446b.png";